const CR_NAV_MENU = {
    HOME: 'HOME',
    ABOUT: 'ABOUT',
    MEDIA: 'MEDIA',
    TEAM: 'TEAM',
    SAMPLE: 'SAMPLE',
};

const CR_URL = '/crypto-read';

const CR_NAV = {
    HOME: {
        title: 'HOME',
        link: '/crypto-read',
    },
    ABOUT: {
        title: 'ABOUT',
        link: 'about',
    },
    MEDIA: {
        title: 'MEDIA',
        link: 'media',
    },
    TEAM: {
        title: 'TEAM',
        link: 'team',
    },
    SAMPLE: {
        title: 'SAMPLE',
        link: '/crypto-read/newsletter',
    },
    CONTACT: {
        title: 'CONTACT',
        link: 'mailTo:cs@cryptocity.tw',
    },
    PRIVACY: {
        title: 'PRIVACY POLICY',
        link: '/crypto-read/privacy-policy',
    },
    UNSUBSCRIBE: {
        title: 'UNSUBSCRIBE',
        link: '/crypto-read/unsubscribe',
    },
    FAQ: {
        title: 'FAQ',
        link: '/crypto-read/FAQ',
    },
};
const CR_PAGE = ['home', 'about', 'media', 'team', 'sample', 'subscribePage', 'faq'];

const CR_BUSINESS_MAIL = 'mailTo:busniess@cryptocity.tw';

const SUBSCRIBE_LINK = 'subscribe';
const RECENT_EDM_LINK = '/crypto-read/newsletter';
const THANK_YOU_PAGE_LINK = '/crypto-read/thank-you';

const FRONT_CONTENT = {
    0: '快速拓展前瞻視野掌握國際、區塊鏈、科技最新趨勢',
    1: 'Expand your forward-looking perspective quickly and grasp the latest trends in international affairs, blockchain, and technology',
};

const ABOUT_CONTENT = {
    0: 'ABOUT',
    1: 'CRYPTO READ',
    2: '每天十分鐘為您精選區塊鏈不可錯過的最新資訊',
};
const ABOUT_INFO = {
    0: {
        title: '幣圈新知',
        subtitle: 'New knowledge in the cryptocurrency world.',
        content:
            '每日精選區塊鏈、加密貨幣領域的重要新聞。由主編篩選，提供深度解析。聚焦市場趨勢、技術創新、政策變化等關鍵議題，幫助您掌握行業發展脈絡。',
    },
    1: {
        title: '科技趨勢',
        subtitle: 'Technology trends News',
        content:
            '聚焦區塊鏈的重大突破與創新應用，彙整新興領域的重要進展。深入剖析這些技術如何影響各行業，探討潛在的商業模式變革。為讀者梳理複雜的技術發展。',
    },
    2: {
        title: '財商思維',
        subtitle: 'Financial intelligence mindset',
        content:
            '分享新時代的財務管理與投資想法。精選財經見解，涵蓋加密資產、去中心化金融等新興領域。分析傳統金融與新興科技的融合趨勢，培養讀者的財務洞察力。',
    },
};

const FAQ_CONTENT = [
    {
        Q: 'Crypto Read 聯合電子報是什麼？ ',
        A: 'Crypto Read 聯合電子報是由區塊客、鏈新聞、桑幣區勢、加密城市等眾多台灣區塊連媒體共同營運的電子報，我們希望透過多元、豐富的新聞選題，為各位讀者帶來更多平常不會接觸到的新聞，並讓對加密貨幣、區塊鏈有興趣的朋友，都能更加輕鬆的，了解這個領域的各項資訊。',
    },
    {
        Q: 'Crypto Read 聯合電子報提供什麼樣的服務？',
        A: '我們會在每週一至五，早上9點發信，為您帶來過去24小時的區塊鏈熱門新聞，每篇新聞都是由當週負責主編選稿，負責主編除了選稿外，也會分享當日心得、觀點、雜談等內容，想看主編們不為人知的一面，都在 Crypto Read 聯合電子報。',
    },
    {
        Q: '如何訂閱 Crypto Read 聯合電子報？',
        A: '在本網站點擊訂閱按鈕，您將可以收到訂閱認證信，打開信件點擊連結，就算訂閱成功囉！ 這時您將會收到我們的歡迎信件，除了感謝您支持 Crypto Read 聯合電子報外，我們也想邀請您一起分享給您的朋友，讓更多人可以看見這項服務。',
    },
    {
        Q: '訂閱 Crypto Read 聯合電子報，需要付費嗎？',
        A: ' Crypto Read 聯合電子報是完全免費的，Crypto Read 聯合電子報是完全免費的，Crypto Read 聯合電子報是完全免費的，因為很重要，所以要說三次，未來也許會有其他商業模式，但訂閱電子報本身，是完全免費的，請放心訂閱',
    },
    {
        Q: 'Crypto Read 聯合電子報 有取得文章作者授權嗎？',
        A: 'Crypto Read 聯合電子報內的每篇新聞都是由合作媒體提供，皆有取得轉載授權，如您對任何一篇新聞有疑慮，歡迎與我們聯繫。',
    },
    {
        Q: 'Crypto Read 聯合電子報 有符合相關法規嗎？',
        A: 'Crypto Read 聯合電子報的營運一切合法合規，相關說明請參考：隱私政策 內容說明。',
    },
    {
        Q: '如果我想退訂 Crypto Read 聯合電子報，怎麼操作？',
        A: '很抱歉沒能為您帶來滿意的服務，您可以透過網站的退訂功能，進行 Crypto Read 聯合電子報 退訂作業，如方便的話，希望您可以告訴我們退訂的原因，我們會持續改進，再次感謝您的訂閱支持。',
    },
];

const PRIVACY_CONTENT = {
    0: {
        title: 'Crypto Read 聯合電子報（以下簡稱：CR）重視您的個人隱私，在使用CR服務時，請詳閱本隱私權保護政策，了解CR如何蒐集、處理及運用您所提供的個人資料，以及如何保護你的資料安全：',
        content: '',
    },
    1: {
        title: '適用範圍',
        content: [
            '隱私權政策適用於CR所有服務，我們可能不定期推出新服務，若推出新服務使收集與使用個人資料的方式有變動，我們會提供變動的項目。',
        ],
    },
    2: {
        title: '資料取得',
        content: [
            '當您瀏覽網站時：CR會保留您在瀏覽或查詢時，於伺服器產生的相關記錄，包括您使用連線設備的IP位址、使用時間、cookies、使用的瀏覽器、瀏覽及點選記錄等。',
        ],
    },
    3: {
        title: '蒐集用途',
        content: [
            '我們會運用所蒐集到的資料，打造客製化的服務，如：文章或活動的個人化推薦。而依據您的設定，CR網站與第三方服務可能會根據您的興趣向您顯示個人化廣告。',
            '我們會向您收集電子郵件與您互動。例如：聯合電子報、不定期寄發活動、訂閱等通知。若您不希望收到任何電子報或通知訊息，可隨時取消訂閱。如您於設定上有任何問題，歡迎隨時與我們聯繫。',
        ],
    },
    4: {
        title: '揭露條件',
        content: [
            '除以下情況，我們不會與外部公司、機構或個人分享您的個人資訊：',
            '服務供應商：為了讓所有產品或服務能順利運作，我們會與雲端資訊服務供應商合作，包括：雲端運算與資料儲存平台、電子報發報系統等服務。',
            '合作夥伴：為改善服務，我們會與第三方的數據分析服務合作，如：Google Analytics，提供您更優質的使用者體驗。',
            '執法、主管機關：依據法律要求，在合理必要的情況下，我們可以披露您的資訊。',
        ],
    },
    5: {
        title: 'Cookie',
        content: [
            'Cookies是網站伺服器端為了區別使用者的喜好，經由瀏覽器寫入使用者硬碟的小型數據文件。',
            '為了提升使用者的瀏覽體驗，CR會在您的電腦上設定並存取網站之cookie。它能辨識區別使用者，以保存使用者上次造訪本網站之設定與一些快取資訊，節省使用者的時間。亦能讓我們統計瀏覽人數及分析瀏覽模式，以便我們更了解您的瀏覽行為，作為改善服務的參考。',
        ],
    },
    6: {
        title: '法規保障',
        content: [
            '個人資料相關內容，均依照中華民國法律予以處理，並以台灣台北地方法院為第一審管轄法院。',
            '我們致力為您的個人資料提供妥善保護，並採取適當的技術與安全維護措施來協助保護您的個人資料安全。',
        ],
    },
    7: {
        title: '刪除和權利',
        content: ['您可在任何時候選擇退訂Mail，即可不再收到CR的任何信件。'],
    },
    8: {
        title: '聯絡我們',
        content: ['若您對我們的隱私權政策有任何問題，歡迎來信與我們聯絡：'],
        link: 'cs@cryptocity.tw',
    },
};

const EMAIL_NOTICE = {
    ERROR: 'Email 地址的 domain 無效（@ 之後的部份）： ',
    FOLLOWED: '已訂閱電子報',
};

const MEDIA_CONTENT = {
    0: 'UNITED',
    1: 'MEDIA',
    2: 'Transparency, Trustworthiness, and Media Innovation in the Digital Age',
    3: '匯聚各大加密產業媒體品牌',
    4: '一站式掌握幣圈新聞、科技趨勢、市場分析和專業觀點',
};
const MEDIA_INFO = [
    {
        title: '區塊客 Blockcast',
        img: '/images/cryptoread/section4/blockcast.png',
        content:
            '「區塊客」於 2017 年 4 月正式成立，旨在廣泛整理全球區塊鏈資訊，增進全球中文閱聽眾及投資人對區塊鏈趨勢的了解。區塊客積極蒐羅並傳遞全球區塊鏈與加密貨幣的第一手資訊，剖析尖端新聞，專題評議關鍵話題，致力服務中文閱聽大眾。',
        type: 'blockcast',
    },
    {
        title: '加密城市 Crypto City',
        img: '/images/cryptoread/section4/cryptocity.png',
        content:
            'Crypto City 創立於2022年,為台港澳地區知名區塊鏈媒體。我們提供最全面的區塊鏈資訊,專注Web3、AI等領域,每日報導業界新聞和實用資訊,促進產業發展。致力成為市場領導者與新用戶間的橋樑,讓區塊鏈更貼近大眾。',
        type: 'cryptoCity',
    },
    {
        title: '鏈新聞 Abmedia',
        img: '/images/cryptoread/section4/abmedia.png',
        content:
            '台灣最值得信賴的區塊鏈媒體「鏈新聞」，我們提供全球區塊鏈與加密貨幣的重要新聞與趨勢報告。「鏈新聞」是透過區塊鏈與加密貨幣重新認識世界的青年科技讀物。',
        type: 'abmedia',
    },
    {
        title: '每日幣研 Crypto Wesearch',
        img: '/images/cryptoread/section4/wesearch.png',
        content:
            '成立於 2021 年，每日幣研致力於提供深入的區塊鏈產業相關資訊 🔎 透過由淺入深的內容幫助更多人了解區塊鏈技術及應用，並以正確的角度深入加密貨幣領域。',
        type: 'wesearch',
    },
    {
        title: '桑幣區勢 Zombit',
        img: '/images/cryptoread/section4/zombit.png',
        content:
            '桑幣區識 Zombit 為專業的區塊鏈財經新聞自媒體，利用自身的金融和區塊鏈知識，提供區塊鏈相關的時事新聞、專題專欄、新手教學等，協助大眾區分、識別正確的新聞與資訊。',
        type: 'zombit',
    },
    {
        title: '手榴彈 Grenade',
        img: '/images/cryptoread/section4/grenade.png',
        content:
            'Grenade 手榴彈為客戶提供內容製作、媒體新聞稿、KOL/KOC、線上/線下活動企劃及執行、SEO、廣告投放等服務。而手榴彈媒體及社群作為橋樑，也為區塊鏈產業生態內的所有用戶，提供最具價值、多元的資訊與資源。',
        type: 'grenade',
    },
];

const TEAM_CONTENT = [
    'TEAM',
    '專業編輯群',
    '聚焦市場趨勢、技術創新、政策變化等關鍵議題，幫助您掌握行業發展脈絡。',
];

const TEAM_INFO = [
    {
        enName: 'Suki',
        title: '區塊客',
        subtitle: '主編',
    },
    {
        enName: 'Wade',
        title: '鏈新聞',
        subtitle: '主編',
    },
    {
        enName: 'Jeff',
        title: '桑幣區識',
        subtitle: '主編',
    },
    {
        enName: 'Max',
        title: '加密城市',
        subtitle: '主編',
    },
    {
        enName: 'Alvin',
        title: '每日幣研',
        subtitle: '創辦人',
    },
    {
        enName: 'Kerry',
        title: 'Grenade',
        subtitle: '主編',
    },
];

const PREVIEW_CONTENT = {
    0: '精彩試閱',
    1: '點此查看近期電子報內容',
};

const THANK_YOU_CONTENT = {
    0: '感謝您訂閱我們的電子報！',
    1: '我們非常高興能夠與您分享最新的資訊和獨家內容。',
    2: '如果您有任何問題或反饋，歡迎隨時聯繫',
    3: '再次感謝您的支持，我們期待與您一起成長！',
};

const UNSUBSCRIBE_CONTENT = {
    0: '退訂電子報',
    1: '如果您不再希望接收電子報，我們會立即處理您的退訂申請，並確保您不再收到來自我們的電子郵件。',
    2: '感謝您過去的支持與關注！',
};

const FOOTER_CONTENT = {
    0: '隱私政策',
    1: '退訂電子報',
    2: 'FAQ',
};
const NEWSLETTER_CONTENT = {
    0: '電子報近期內容一覽',
};

const NEWSLETTER_EMPTY_CONTENT = {
    0: '電子報編輯中...',
    1: '目前沒有近期的電子報內容',
};

const SUBSCRIBE_CONTENT = {
    0: '立即訂閱',
    1: '免費訂閱 5,000+ 人追蹤的「CRYPTO READ」電子報',
    2: '每天早晨讓你輕鬆接軌國際區塊鏈動態，掌握科技、商業新脈動',
};
const SUBSCRIBE_CONTENT_POP = {
    0: '立即訂閱',
    1: '每週一至五 早上9:00',
    2: '為您提供最重要的區塊鏈時事新聞！',
};
const EMAIL_CONTENT = {
    0: '請驗證信箱',
    1: '請前往Email收取確認信',
    2: 'Crypto Read已寄出一封驗證信至 ',
    3: '，請至信箱收信，點擊信中連結進行驗證。',
    4: '未收到信件？',
    5: '請檢查垃圾郵件資料夾，或',
    6: '再次寄發驗證信',
};

export {
    CR_NAV_MENU,
    CR_URL,
    CR_NAV,
    CR_PAGE,
    CR_BUSINESS_MAIL,
    SUBSCRIBE_LINK,
    RECENT_EDM_LINK,
    THANK_YOU_PAGE_LINK,
    FRONT_CONTENT,
    ABOUT_CONTENT,
    ABOUT_INFO,
    MEDIA_CONTENT,
    MEDIA_INFO,
    TEAM_CONTENT,
    TEAM_INFO,
    PREVIEW_CONTENT,
    FAQ_CONTENT,
    PRIVACY_CONTENT,
    EMAIL_NOTICE,
    THANK_YOU_CONTENT,
    UNSUBSCRIBE_CONTENT,
    FOOTER_CONTENT,
    NEWSLETTER_CONTENT,
    NEWSLETTER_EMPTY_CONTENT,
    SUBSCRIBE_CONTENT,
    SUBSCRIBE_CONTENT_POP,
    EMAIL_CONTENT,
};
